module.exports = __webpack_public_path__ + "media/images/banner/unipolsai_mobile-230104e85b1d52781e6b2a8b52a19d1a.gif";